export const DEFAULT_SPINNER = 'defaultSpinner';
export const IFRAME = 'iFrame';
export const MOBILE_VALIDATION_HANDLE_SUBMIT = 'mobileValidationHandleSubmit';
export const APPLY_SECTION = 'applySection';
export const READ_LOAN_APPLICATION = 'readLoanApplication';
export const SAVE_STRUCTURE_FOR_LOAN_APPLICATION =
  'saveStructureForLoanApplication';
export const SAVE_STRUCTURE = 'saveStructure';
